import { createAction, props } from '@ngrx/store';
import { DatesAndAccupancy, HotelBookingData, HotelBookingRequest, ImagesData, Proposition, WidgetData } from '../index.types';
import { TranslationObject } from '@ngx-translate/core';

export enum ActionTypes {
    WidgetDataLoaded            = '[Widget Feature] widget data loaded',
    OffsetChanged               = '[Widget Feature] OffsetChanged',
    DatesAndAccupancySubmitted  = '[Widget Feature] dates and accupancy form submitted',
    MobileSearchVisibility      = '[Widget Mobile Feature] search requested',
    TranslationsRequested       = '[Widget Feature] translations requested',
    TranslationsLoaded          = '[Widget Feature] translations loaded',
    CommentsRequested           = '[Widget Feature] comments requested',
    CommentsLoaded              = '[Widget Feature] comments loaded',
    CommentsFailed              = '[Widget Feature] comments failed',
    HotelBookingDataLoaded      = '[Widget Feature] hotel booking data loaded',
    HotelBookingDataFailed      = '[Widget Feature] hotel booking data failed',
    HotelBookingDataEngineFailed= '[Widget Feature] hotel booking data engine failed',
    HotelBookingDataRequested   = '[Widget Feature] hotel booking data requested',
    PropositionRequested        = '[Widget Feature] proposition requested',
    PropositionLoaded           = '[Widget Feature] proposition loaded',
    SearchPanelVisibility       = '[Widget Feature] searchPanel visibility changed',
    UpdateSearchPanelVisibility = '[Widget Feature] searchPanel visibility updated',
    HotelBookingDataRequestEnds = '[Widget Feature] hotel booking data request ends',
    ImagesRequested             = '[Widget Feature] Images requested',
    ImagesDataLoaded            = '[Widget Feature] Images data loaded',
    Minimize                    = '[Widget Feature] Minimize',
    Maximize                    = '[Widget Feature] Maximize'
}

export const WidgetDataLoaded           = createAction(ActionTypes.WidgetDataLoaded, props<{ data: WidgetData  }>());
export const OffsetChanged              = createAction(ActionTypes.OffsetChanged, props<{ offset: { height: string, width: string} | string  }>());
export const DatesAndAccupancySubmitted = createAction(ActionTypes.DatesAndAccupancySubmitted, props<{ datesAndAccupancy: DatesAndAccupancy }>());

export const MobileSearchVisibility     = createAction(ActionTypes.MobileSearchVisibility, props<{ visible: boolean  }>());

export const TranslationRequested       = createAction(ActionTypes.TranslationsRequested, props<{ data: WidgetData  }>())
export const TranslationLoaded          = createAction(ActionTypes.TranslationsLoaded, props<{ translations: TranslationObject, widgetData: WidgetData }>())

export const CommentsRequested          = createAction(ActionTypes.CommentsRequested, props<{ id_hotel_in_bo: number  }>())
export const CommentsLoaded             = createAction(ActionTypes.CommentsLoaded, props<{ comments:  any}>())
export const CommentsFailed             = createAction(ActionTypes.CommentsFailed, props<{ error:  any}>())

export const HotelBookingDataRequested  = createAction(ActionTypes.HotelBookingDataRequested, props<{ request: HotelBookingRequest  }>())
export const HotelBookingDataLoaded     = createAction(ActionTypes.HotelBookingDataLoaded, props<{ hotelBookingData:  Record<string, HotelBookingData>}>())
export const HotelBookingDataFailed     = createAction(ActionTypes.HotelBookingDataFailed, props<{ error:  any}>())
export const HotelBookingDataEngineFailed   = createAction(ActionTypes.HotelBookingDataEngineFailed, props<{ error:  any}>())
export const HotelBookingDataRequestEnds    = createAction(ActionTypes.HotelBookingDataRequestEnds, props<{ request: HotelBookingRequest  }>())

export const PropositionRequested       = createAction(ActionTypes.PropositionRequested, props<{ request: HotelBookingRequest  }>())
export const PropositionLoaded          = createAction(ActionTypes.PropositionLoaded, props<{ proposition: Proposition[]}>())

export const SearchPanelVisibility      = createAction(ActionTypes.SearchPanelVisibility, props<{ open: boolean  }>());
export const UpdateSearchPanelVisibility= createAction(ActionTypes.UpdateSearchPanelVisibility, props<{ open: boolean  }>());

export const ImagesRequested            = createAction(ActionTypes.ImagesRequested, props<{ request: HotelBookingRequest  }>())
export const ImagesDataLoaded           = createAction(ActionTypes.ImagesDataLoaded, props<{ imagesData: ImagesData}>())

export const Minimize                   = createAction(ActionTypes.Minimize, props<{ force?: boolean}>())
export const Maximize                   = createAction(ActionTypes.Maximize)